import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import PoweredByJibber from '/chat/src/components/PoweredByJibber';
import SystemModel from '/chat/src/redux/model/system/model';
import style from './style.scss';

import HeaderTitle from '/chat/src/components/Header/Title';
import HeaderAutomessage from '/chat/src/components/Header/AutoMessage'
import {CloseButton, FaqButton, BackButton} from '/chat/src/components/Buttons';
import HeaderRightToolBelt from '/chat/src/components/Header/Toolbelt/RightSide'
import Customization from '/chat/src/redux/model/customization/model';

class Header extends Component {
    constructor(props){
        super(props);
        this.state = {
            HeaderHeight: 0,
        }
    }

    render(){
        const company = this.props.company;
        const automessage = this.props.automessage;
        const hasFaq = this.props.features.get('hasFaq');

        const welcomeTo = this.props.language.get("WelcomeTo")

        return(
            <div style={{backgroundColor: this.props.color}}>
                <div className={style.Header}>
                    <BackButton/>
                    <HeaderTitle body={this.props.language.get('Settings')}/>
                    <HeaderRightToolBelt>
                        {hasFaq &&<FaqButton/>}
                        <CloseButton/>
                    </HeaderRightToolBelt>
                </div>
            </div>
        )

    }
}


function mapStateToProps(state) {
    const color = Customization.getColor(state)
    const language = Customization.getLanguage(state)
    return {
        color: color,
        language: language,
        company: state.get('company'),
        automessage: state.getIn(['autoMessages', 'currentAutoMessage']),
        features: state.get('features'),
        system: state.get('system'),
    };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./routes/Settings/Header.js